<!--
	引用方法:
	在需要的组件中
	1.import ActionModal from './components/common/ActionModal'
	2.<action-modal v-if="$store.state.actionModal.showActionModal" @selectRes="selectRes"></action-modal>
	3.components中注册组件
	4.this.$store.commit('showActionModal',{
		showActionModal:true,
		info:'证据固化费用：5元/条，确认继续吗？'

	  })
	5.methods中定义selectRes方法,从参数中接收用户选择结果
	  eg:
		  methods:{
			selectRes (res) {
				console.log(res);
			}
		  }
    6.结果为true或者false
 -->

<template>
	<transition name="fade">
	<div class="modal-box">
		<div class="context" @click="closeModal"></div>
		<div class="modal">
			<div class="modal-title">
				消息提示
				<span class="modal-close" @click="closeModal">
					<img src="../../assets/images/common/x.png">
				</span>
			</div>
			<div class="modal-content">{{$store.state.msgModal.setModal.info}}</div>
			<!-- <div class="modal-btn">
				<button class="modal-cancel" @click="cancel" v-html="cancelText"></button>
				<button class="modal-confirm" @click="confirm" v-html="confirmText"></button>
			</div> -->
		</div>
	</div>
	</transition>
</template>

<script>
	export default {
		name: 'MsgModal',
		data () {
			return {
				confirmText: '确认',
				cancelText: '取消',
			}
		},
		props: ['btnText'],
		created () {
		  // console.log("btnText:", this.btnText)
			if (this.btnText) {
		    this.confirmText = this.btnText.confirmText
		    this.cancelText = this.btnText.cancelText
			}
		},
		methods: {
			closeModal () {
				this.$store.commit('showActionModal', false);
			},
			confirm () {
				this.$emit('selectRes', true);
				this.$store.commit('showActionModal', false);
			},
			cancel () {
				this.$emit('selectRes', false);
				this.$store.commit('showActionModal', false);
			}
		}
	}
</script>

<style scoped>
.modal-box,
.context{
	height: 100%;
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99;
	font-size: 14px;
}
.context{
	background-color: rgba(0,0,0,0.4);
}
.modal{
  position: absolute;
  min-height: 154px;
  width: 340px;
  left:50%;
  top:40%;
  transform: translate(-50%,-50%);
  background-color: #ffffff;
  border-radius: 8px;
  z-index: 999;
}
.modal-title{
	height: 40px;
	line-height: 40px;
	background-color: #d03346;
	color:#fff;
	padding-top: 1px;
	margin-top: -1px;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	text-align: center;
	position: relative;
}
.modal-close{
	position: absolute;
	right: 12px;
	top: 0px;
	width: 12px;
	height: 12px;
	display: block;
	text-align: center;
	cursor: pointer;
}
.modal-close img{
	width: 100%;
}
.modal-content{
	min-height: 50px;
  padding: 32px 18px;
  text-align: center;
	word-wrap: break-word;
}
.modal-btn{
	text-align: center;
	padding-bottom: 20px;
}
.modal-btn button{
	border:0;
	width: 80px;
	height: 30px;
	border:1px solid #acacac;
	background-color: #fff;
	border-radius: 5px;
}
.modal-btn button:hover{
	color:#d03346;
	border: 1px solid #d03346;
}
.modal-btn .modal-confirm{
	margin-left: 30px;
}
.modal-btn .modal-cancel{
	margin-right: 30px;
}
/*transition Start*/
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
/*transition End*/
</style>
